var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-page"},[_c('section',{staticClass:"contact-hero"},[_c('div',{staticClass:"hero-content"},[_c('p',{staticClass:"hero-subtitle"},[_vm._v("WE'D LOVE TO HEAR FROM YOU")]),_c('h1',[_vm._v("Get In Touch")]),_c('p',[_vm._v(" Have a question, need help with an order, or simply want to say hello? We're here to help. ")])])])])
}]

export { render, staticRenderFns }